import PreviewPost from './PreviewPost';

export default PreviewPost;
